import { EventPropertiesInput } from './eventInputTypes';

type FilterNullishProperties = (properties: EventPropertiesInput) => EventPropertiesInput;
export const filterNullishProperties: FilterNullishProperties = (properties) =>
  Object.keys(properties).reduce((keptProperties, key) => {
    const property = properties[key];

    return property == null ? keptProperties : { ...keptProperties, [key]: property };
  }, {});
